import * as z from "zod";
import i18n from './i18n';

// Validation Messages
const vm = {
    required: i18n.t('Required'),
    invalidFormat: i18n.t('Invalid format'),
    invalidEmail: i18n.t('Invalid Email'),
    invalidPhone: i18n.t('Invalid Phone'),
    invalidDate: i18n.t('Invalid Date'),
    invalidZipCode: i18n.t('Invalid Zip Code'),
    selectAnOption: i18n.t('Select an option'),
}

// Validation Functions
export const text = (customMessage) => {
  return z.string({ required_error: customMessage || vm.required, invalid_type_error: customMessage || vm.required });
};

export const textOptionalEmpty = (customMessage) => {
  return z.string({ required_error: customMessage || vm.required, invalid_type_error: customMessage || vm.required }).optional().default('');
};

export const textRequired = (customMessage) => {
  return z.string({ required_error: customMessage || vm.required, invalid_type_error: customMessage || vm.required }).min(1, { message: customMessage || vm.required });
};

export const textNullableOptional = (customMessage) => {
  return z.string({ required_error: customMessage || vm.required, invalid_type_error: customMessage || vm.required }).nullable().optional();
};

export const emailRequired = (customMessage) => {
  return z.string({ required_error: customMessage || vm.required, invalid_type_error: customMessage || vm.invalidEmail }).min(1, { message: customMessage || vm.required }).email(customMessage || vm.invalidEmail)
};

export const emailOptionalEmpty = (customMessage) => {
  return z.string().email(customMessage || vm.invalidEmail).or(z.literal('')).optional().default('')
}

export const phoneRequired = (customMessage) => {
  return z
    .string({ 
      required_error: customMessage || vm.required, 
      invalid_type_error: customMessage || vm.invalidPhone 
    })
    .length(10, { message: customMessage || vm.invalidPhone }) // Debe tener exactamente 10 dígitos
    .regex(/^\d+$/, { message: customMessage || vm.invalidPhone });
};

export const phoneOptionalEmpty = (customMessage) => {
  return z.string()
    .optional()
    .refine(value => value === undefined || value === '' || /^\d{10}$/.test(value), {
      message: customMessage || vm.invalidPhone,
    }).default('');
}

export const dateRequired = (customMessage) => {
  return z.string({ required_error: customMessage || vm.invalidFormat, invalid_type_error: customMessage || vm.required }).min(1, { message: customMessage || vm.required }).date(customMessage || vm.invalidDate);
};

export const zipCodeRequired = (customMessage) => {
  return z.string({ required_error: customMessage || vm.required, invalid_type_error: customMessage || vm.required }).min(1, { message: customMessage || vm.required }).regex(/^\d{5}(-\d{4})?$/, customMessage || vm.invalidZipCode);
}

export const zipCodeOptionalEmpty = (customMessage) => {
  return z.string()
  .optional()
  .refine(value => value === undefined || value === '' || /^\d{5}(-\d{4})?$/.test(value), {
    message: customMessage || vm.invalidZipCode,
  }).default('');
}

export const zipCodeNullableOptional = (customMessage) => {
  return z.string({ required_error: customMessage || vm.required, invalid_type_error: customMessage || vm.required }).regex(/^\d{5}(-\d{4})?$/, customMessage || vm.invalidZipCode).nullable().optional();
}

export const booleanNullableOptional = (customMessage) => {
  return z.boolean().optional();
}

export const selectWithNumberValueRequired = (customMessage) => {
  return z.preprocess(
    (val) => parseInt(val, 10), 
    z.number({
      required_error: customMessage || vm.required,
      invalid_type_error: customMessage || vm.selectAnOption,
    })
    .int()
    .positive()
    .min(1, { message: customMessage || vm.selectAnOption })
  );
};

export const selectWithNumberValueNullableOptional = (customMessage) => {
  return z.preprocess(
    (val) => (val === '' || val == null ? null : parseInt(val, 10)),
    z.number({
      required_error: customMessage || vm.required,
      invalid_type_error: customMessage || vm.selectAnOption,
    })
    .int()
    .min(0, { message: customMessage || vm.selectAnOption })
    .nullable()
    .optional()
  );
};
  